import { usePositionBalances } from '~/components/smart-accounts/positions'
import { useVestingBalances } from '~/components/smart-accounts/vesting/hooks/useVestingBalances'
import {
  useOrgSmartAccount,
  SmartAccountBalancesGroupBy,
  useSmartAccountDisplayedBalances,
} from '~/hooks/useSmartAccounts'
import { useSmartAccountsShowSmallBalances } from '~/hooks/utils'
import { EvmAddress } from '~/utils/address'
import { isVaultToken } from '~/utils/vault'

export const useShowPositionSubHeading = ({
  address,
}: {
  address: EvmAddress.Type
}) => {
  const { smartAccount, isLoading: isLoadingSmartAccount } =
    useOrgSmartAccount(address)
  const { data: vestingBalances, isLoading: isLoadingVestingBalances } =
    useVestingBalances(smartAccount?.id, smartAccount?.orgId)
  const { data: positionBalances, isLoading: isLoadingPositionBalances } =
    usePositionBalances(smartAccount?.id, smartAccount?.orgId)

  const { showSmallBalances } = useSmartAccountsShowSmallBalances()

  const { balances: groupedBalances, isLoading: isLoadingBalances } =
    useSmartAccountDisplayedBalances(address, {
      showSmallBalances,
      balancesGroupBy: SmartAccountBalancesGroupBy.Chain,
      tokenFilter: isVaultToken,
    })
  const balances = groupedBalances
    .map(({ groupBalances }) => groupBalances)
    .flat()
    .sort((a, b) => (b.usdValue ?? 0) - (a.usdValue ?? 0))

  const hasPositions =
    balances.length > 0 ||
    (vestingBalances && vestingBalances.length > 0) ||
    (positionBalances && positionBalances.length > 0)

  if (
    (isLoadingSmartAccount ||
      isLoadingBalances ||
      isLoadingVestingBalances ||
      isLoadingPositionBalances) &&
    !hasPositions
  ) {
    return false
  }

  return hasPositions
}
